export default {
  NO_DATA: 'Không có dữ liệu',
  NO_MATCHED_STOCK: 'Không có cổ phiếu tương thích',
  NO_MATCHED_CW: 'Không có mã chứng quyền tương thích',
  DONE: 'HOÀN THÀNH',
  CANCEL: 'HỦY',
  CREATE: 'TẠO',
  YES: 'ĐỒNG Ý',
  table: {
    TABLE_FOOTER_TEXT:
      'Giá: x 1,000. Khối lượng: x 1,000. Giá Trị: x 1,000,000',
    TABLE_FOOTER_TEXT_WITH_UNIT:
      'Giá: x1000 (VND). Khối lượng: x1000 (CP). Giá trị: x1000000 (VND)',
    SIMPLE_TABLE_FOOTER_TEXT: 'Giá: x 1,000. Khối lượng: x 1,000',
    NO_DATA: 'Không có dữ liệu',
    ZMF_SCORE_TEXT:
      'Để thêm chi tiết về cách tính toán Z-Score, M-Score và F-Score',
  },
  button: {
    delete: 'XÓA',
    cancel: 'HỦY',
    save: 'LƯU',
  },
  lstLabelCalendar: {
    from: 'Từ',
    to: 'Đến',
    startDate: 'Ngày Bắt Đầu',
    endDate: 'Ngày Kết Thúc',
    apply: 'Áp Dụng',
    formatDate: 'MM/DD/YYYY',
  },
  searchAdd: {
    search: 'Tìm kiếm',
    add: 'Thêm',
  },
  search: 'Tìm kiếm',
  listComponent: {
    Market: 'Thị trường',
    Price: 'Giá',
    Fundamental: 'PT cơ bản',
    Technical: 'PT kỹ thuật',
    NewsAndAnalysis: 'Tin tức và nhận định',
    Tools: 'Công cụ đầu tư',
    ST: 'Chiến lược đầu tư',
    MarketInDepth: 'Thị trường chuyên sâu',
    Watchlist: 'Danh mục',
    TopVolume: 'Top Khối lượng',
    TopBreakout: 'Top Đột phá',
    TopValue: 'Top Giá trị',
    TopGainers: 'Top tăng Giá',
    TopLosers: 'Top giảm Giá',
    TopNewHigh: 'Top vượt đỉnh',
    TopNewLow: 'Top thủng đáy',
    TopForeignTrade: 'Top NDTNN',
    MarketCalendar: 'Lịch Sự kiện',
    HeatMap: 'Bản đồ Nhiệt',
    MoneyFlow: 'Xu hướng dòng tiền',
    TimeAndSales: 'Time & Sales',
    PriceDepth: 'Chi tiết bước giá',
    QuoteMovement: 'Chi tiết khớp lệnh',
    PriceData: 'Thống kê giá',
    Charting: 'Biểu đồ PT kỹ thuật',
    FADividendAnalysis: 'Cổ tức và Dự báo',
    TASignals: 'Tín hiệu kỹ thuật',
    FinancialAnalysis: 'Phân tích tài chính',
    FinancialRatio: 'Chỉ số Tài Chính',
    Ownership: 'Sở hữu và GD nội bộ',
    FinancialStatement: 'Báo cáo tài chính',
    FASnapshot: 'Báo cáo Doanh nghiệp',
    News: 'Tin tức',
    Alerts: 'Cảnh báo',
    Screener: 'Bộ lọc cổ phiếu',
    Valuation: 'Mô hình định giá',
    ConsensusAnalysis: 'Phân tích Consensus',
    STRanking: 'Xếp hạng cổ phiếu',
    Strategy: 'Chiến lược đầu tư',
    TradeData: 'FiinTA',
    Order: 'Order',
  },
  minutes: 'phút',
  seconds: 'giây',
  marketPreOpenTitle: 'Thị trường sẽ mở cửa trong',
  labelPopupDragComponent: 'Kéo và Thả ở vị trí phù hợp',
  pressEscToExit: ' Nhấn [ESC] để hủy bỏ.',
  POPOUT: 'Popout',
  TITLE_POPUP_BUY_SELL: 'CHỌN CÔNG TY CHỨNG KHOÁN',
  TITLE_POPUP_TUTORIAL: 'HƯỚNG DẪN HỆ THỐNG FIINTRADE',
  EXPORT: 'TẢI XUỐNG',
  PRINT: 'IN',
  headline: 'Tiêu Đề',
  buy: 'Mua',
  sell: 'Bán',
  points: 'ĐIỂM',
  watchOut: {
    title: 'Cảnh báo',
    description: 'Đã được liệt kê trong',
  },
  close: 'đóng',
  maximise: 'tối đa',
  minimise: 'tối thiểu',
  popout: 'mở cửa sổ mới',
  shareOnSkype: 'Chia sẻ trên Skype',
  export: {
    marketIndepth: {
      valuation: 'FiinTrade_Định_Giá_%{date}',
    },
    topMover: {
      1: 'FiinTrade_%{name}_Tổng_Quan_%{date}',
      2: 'FiinTrade_%{name}_Biến_Động_%{date}',
      3: 'FiinTrade_%{name}_Tài_Chính_%{date}',
      4: 'FiinTrade_%{name}_Kỹ_Thuật_%{date}',
    },
    timesAndSales: 'FiinTrade_Time&Sales_%{ticker}_%{date}',
    priceData: {
      1: 'FiinTrade_Giá_%{ticker}_%{date}',
      2: 'FiinTrade_Đặt_Lệnh_%{ticker}_%{date}',
      3: 'FiinTrade_Nước_Ngoài_%{ticker}_%{date}',
      4: 'FiinTrade_Tự_Doanh_%{ticker}_%{date}',
    },
    snapshot: 'FiinTrade_Báo_Cáo_Doanh_Nghiệp_%{ticker}_%{date}',
    ownership: {
      1: 'FiinTrade_Cổ_Đông_Lớn_%{ticker}_%{date}',
      2: 'FiinTrade_Ban_Lãnh_Đạo_%{ticker}_%{date}',
    },
    financialAnalysis: {
      financialRatio: 'FiinTrade_Chỉ_Số_Tài_Chính_%{ticker}_%{date}',
      zmfScore: 'FiinTrade_Điểm_ZMF_%{ticker}_%{date}',
    },
    cashDividendAnalysis: 'FiinTrade_Cổ_Tức_Và_Dự_Báo_%{ticker}_%{date}',
    financialStatement: {
      balanceSheet: 'FiinTrade_Cân_Đối_Kế_Toán_%{ticker}_%{date}',
      incomeStatement: 'FiinTrade_Kết_Quả_Kinh_Doanh_%{ticker}_%{date}',
      cashFlowStatement: 'FiinTrade_Lưu_Chuyển_Tiền_Tệ_%{ticker}_%{date}',
    },
    stockScreener: {
      1: 'FiinTrade_Bộ_lọc_cổ_phiếu_Tổng_Quan_%{date}',
      2: 'FiinTrade_Bộ_lọc_cổ_phiếu_Biến_Động_%{date}',
      3: 'FiinTrade_Bộ_lọc_cổ_phiếu_Tài_Chính_%{date}',
      4: 'FiinTrade_Bộ_lọc_cổ_phiếu_Kỹ_Thuật_%{date}',
    },
    ranking: {
      fiinTradeRankings: 'FiinTrade_FiinTrade_Xếp_Hạng_%{group}_%{date}',
      all: 'Fiintrade_Đánh_Giá_Tất_Cả_%{date}',
      hose: 'Fiintrade_Đánh_Giá_HOSE_%{date}',
      hnx: 'Fiintrade_Đánh_Giá_HNX_%{date}',
    },
    strategy: {
      value: 'FiinTrade_Giá_Trị_%{date}',
      growth: 'FiinTrade_Tăng_Trưởng_%{date}',
      momentum: 'FiinTrade_Động_Lực_%{date}',
      vgm: 'FiinTrade_VGM_%{date}',
      leaders: 'FiinTrade_Dẫn_Đầu_%{date}',
      canSlim: 'FiinTrade_Canslim_%{date}',
    },
  },
  bullish: 'Tăng',
  bearish: 'Giảm',
  strongBullish: 'Tăng mạnh',
  strongBearish: 'Giảm mạnh',
  neutral: 'Trung tính ',
  all: 'Tất cả',
  login: 'Đăng nhập',
  buyUp: 'Mua chủ động (BU)',
  sellDown: 'Bán chủ động (SD)',
  price: 'Giá',
  time: 'Thời gian',
  busd: {
    volume: 'Khối lượng (Nghìn)',
    price: 'Giá',
    index: 'Index',
  },
  noData: 'Không có dữ liệu',
  listComponentWithTab: {
    marketInDepth: {
      index: 'Thị trường chuyên sâu/Chỉ số',
      prospect: 'Thị trường chuyên sâu/Các Thị Trường',
      valuation: 'Thị trường chuyên sâu/Định Giá',
      liquidity: 'Thị trường chuyên sâu/Thanh khoản',
      marketAnomaly: 'Thị trường chuyên sâu/Biến Động',
    },
    topVolume: {
      overview: 'Top Khối lượng/Tổng Quan',
      performance: 'Top Khối lượng/Biến Động',
      financial: 'Top Khối lượng/Tài Chính',
      technical: 'Top Khối lượng/Kỹ Thuật',
      chart: 'Top Khối lượng/Biểu Đồ',
    },
    TopBreakout: {
      overview: 'Top Đột phá/Tổng Quan',
      performance: 'Top Đột phá/Biến Động',
      financial: 'Top Đột phá/Tài Chính',
      technical: 'Top Đột phá/Kỹ Thuật',
      chart: 'Top Đột phá/Biểu Đồ',
    },
    TopValue: {
      overview: 'Top Giá trị/Tổng Quan',
      performance: 'Top Giá trị/Biến Động',
      financial: 'Top Giá trị/Tài Chính',
      technical: 'Top Giá trị/Kỹ Thuật',
      chart: 'Top Giá trị/Biểu Đồ',
    },
    TopGainers: {
      overview: 'Top tăng Giá/Tổng Quan',
      performance: 'Top tăng Giá/Biến Động',
      financial: 'Top tăng Giá/Tài Chính',
      technical: 'Top tăng Giá/Kỹ Thuật',
      chart: 'Top tăng Giá/Biểu Đồ',
    },

    TopLosers: {
      overview: 'Top giảm Giá/Tổng Quan',
      performance: 'Top giảm Giá/Biến Động',
      financial: 'Top giảm Giá/Tài Chính',
      technical: 'Top giảm Giá/Kỹ Thuật',
      chart: 'Top giảm Giá/Biểu Đồ',
    },
    TopNewHigh: {
      overview: ' Top vượt đỉnh/Tổng Quan',
      performance: ' Top vượt đỉnh/Biến Động',
      financial: ' Top vượt đỉnh/Tài Chính',
      technical: ' Top vượt đỉnh/Kỹ Thuật',
      chart: ' Top vượt đỉnh/Biểu Đồ',
    },
    TopNewLow: {
      overview: 'Top thủng đáy/Tổng Quan',
      performance: 'Top thủng đáy/Biến Động',
      financial: 'Top thủng đáy/Tài Chính',
      technical: 'Top thủng đáy/Kỹ Thuật',
      chart: 'Top thủng đáy/Biểu Đồ',
    },
    TopForeignTrade: {
      overview: 'Top NDTNN/Tổng Quan',
      performance: 'Top NDTNN/Biến Động',
      financial: 'Top NDTNN/Tài Chính',
      technical: 'Top NDTNN/Kỹ Thuật',
      chart: 'Top NDTNN/Biểu Đồ',
    },
    HeatMap: {
      marketCap: 'Bản đồ Nhiệt/Vốn Hóa',
      volume: 'Bản đồ Nhiệt/Khối Lượng',
      value: 'Bản đồ Nhiệt/Giá Trị',
      buyVol: 'Bản đồ Nhiệt/KLNN Mua',
      sellVol: 'Bản đồ Nhiệt/KLNN Bán',
      buyVal: 'Bản đồ Nhiệt/GTNN Mua',
      sellVal: 'Bản đồ Nhiệt/GTNN Bán',
    },

    MoneyFlow: {
      contribution: 'Xu hướng dòng tiền/Tỷ Trọng',
      foreign: 'Xu hướng dòng tiền/Nước ngoài',
      proprietary: 'Xu hướng dòng tiền/Tự Doanh',
    },

    TimeAndSales: {
      name: 'Time & Sales',
    },

    PriceDepth: {
      name: 'Chi tiết bước giá',
    },

    PriceData: {
      overview: 'Thống kê giá/Tổng Quan',
      orderStatistic: 'Thống kê giá/Đặt lệnh',
      foreign: 'Thống kê giá/Nước ngoài',
      proprietary: 'Thống kê giá/Tự Doanh',
    },

    Charting: {
      name: 'Biểu đồ PT kỹ thuật',
    },

    TASignals: {
      indicatorSignal: 'Tín hiệu kỹ thuật/Chỉ tiêu',
      deceptive: {
        overview: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Tổng Quan',
        cefl: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Mua Trần/Bán Sàn',
        cancelled: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Hủy Lệnh',
        pressing: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Đè Giá',
        aggressive: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Mua/Bán Chủ Động',
        closing: 'Tín hiệu kỹ thuật/Tín hiệu Nhiễu/Chốt Phiên',
      },
      priceVolumeAnalysis: 'Tín hiệu kỹ thuật/Phân tích Giá - KL',
    },
    News: {
      fiintradeDiary: 'Tin tức/Nhật ký FiinTrade',
      fiintradeCall: 'Tin tức/FiinTrade Call',
      autoNews: 'Tin tức/Tin Tự Động',
      newsAggregator: 'Tin tức/Tin Tổng Hợp',
    },
    FASnapshot: {
      name: 'Báo cáo Doanh nghiệp',
    },
    Ownership: {
      majorShareholder: 'Sở hữu và GD nội bộ/Cổ Đông Lớn',
      bod: 'Sở hữu và GD nội bộ/Ban Lãnh Đạo',
    },
    FinancialAnalysis: {
      FACheckup: 'Phân tích tài chính/Phân tích Nhanh',
      ZMFScore: 'Phân tích tài chính/Điểm ZMF',
    },
    FinancialRatio: {
      name: 'Chỉ số tài chính',
    },
    FADividendAnalysis: {
      name: 'Cổ tức và dự báo',
    },
    ConsensusAnalysis: {
      name: 'Phân tích Consensus',
    },
    FinancialStatement: {
      balanceSheet: 'Báo cáo tài chính/Cân Đối Kế Toán',
      incomeStatement: 'Báo cáo tài chính/Kết Quả Kinh Doanh',
      cashFlowStatement: 'Báo cáo tài chính/Lưu Chuyển Tiền Tệ',
    },
    Alerts: {
      name: 'Cảnh báo',
    },
    Screener: {
      name: 'Bộ lọc cổ phiếu',
    },
    Valuation: {
      name: 'Mô hình định giá',
    },
    TradeData: {
      name: 'FiinTA',
    },
    STRanking: {
      fiintradeRanking: 'Xếp hạng cổ phiếu/FiinTrade Xếp Hạng',
      allScore: 'Xếp hạng cổ phiếu/Đánh Giá',
    },
    Strategy: {
      fiintradeStrategy: {
        overview: 'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/Tổng Quan',
        value: 'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/ĐT Giá Trị',
        growth:
          'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/ĐT Tăng Trưởng',
        momentum:
          'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/ĐT Động Lực',
        vgm: 'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/VGM',
        leaders: 'Chiến lược đầu tư/Chiến lược đầu tư của FiinTrade/CP Dẫn Đầu',
      },
      canSlim: 'Chiến lược đầu tư/Chiến lược CANSLIM',
      taStrategy: {
        accummulation: 'Chiến lược đầu tư/Chiến lược TA/Tích lũy',
        breakout: 'Chiến lược đầu tư/Chiến lược TA/Vượt Đỉnh/Thủng Đáy',
        breakoutMA: 'Chiến lược đầu tư/Chiến lược TA/Vượt MA',
        bestInDowntrend: 'Chiến lược đầu tư/Chiến lược TA/CP Tốt Trong Đà Giảm',
        marketAnomaly: 'Chiến lược đầu tư/Chiến lược TA/Biến Động Thị Trường',
      },
    },
  },
  poweredByFiinTrade: `Cung cấp bởi `,
};
